import { formatDistanceToNowStrict, subDays } from "date-fns";

export const timeAgo = (dateString: string) : string => {
  if (!dateString) return "";
  return formatDistanceToNowStrict(new Date(dateString), { addSuffix: true });
}

export const yesterday = subDays(new Date(), 1);
export const oneWeekAgo = subDays(new Date(), 7);
export const thirtyDaysAgo = subDays(new Date(), 30);